module.exports = __webpack_public_path__ + "img/schedules.16b5fa22.png";